import { createContext } from 'react';
import { EventsContextTypes } from '../../types';

export const HRContext = createContext<EventsContextTypes | any>({});

export default HRContext;
